var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28662 7.99959C3.28662 7.81216 3.3612 7.63241 3.49396 7.49988C3.62671 7.36735 3.80677 7.2929 3.99451 7.2929H7.2914V4.00161C7.2914 3.81419 7.36598 3.63444 7.49873 3.50191C7.63149 3.36938 7.81154 3.29492 7.99929 3.29492C8.18703 3.29492 8.36709 3.36938 8.49984 3.50191C8.6326 3.63444 8.70718 3.81419 8.70718 4.00161V7.2929H12.0041C12.1918 7.2929 12.3719 7.36735 12.5046 7.49988C12.6374 7.63241 12.712 7.81216 12.712 7.99959C12.712 8.18701 12.6374 8.36676 12.5046 8.49929C12.3719 8.63182 12.1918 8.70628 12.0041 8.70628H8.70718V11.9976C8.70718 12.185 8.6326 12.3647 8.49984 12.4973C8.36709 12.6298 8.18703 12.7043 7.99929 12.7043C7.81154 12.7043 7.63149 12.6298 7.49873 12.4973C7.36598 12.3647 7.2914 12.185 7.2914 11.9976V8.70628H3.99451C3.80677 8.70628 3.62671 8.63182 3.49396 8.49929C3.3612 8.36676 3.28662 8.18701 3.28662 7.99959Z",
    fill: "url(#paint0_linear_2078_5169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57934 0.243849C6.51706 -0.081283 9.48177 -0.081283 12.4195 0.243849C14.1439 0.436068 15.5361 1.79197 15.7381 3.52289C16.0873 6.49758 16.0873 9.50242 15.7381 12.4771C15.5352 14.208 14.143 15.563 12.4195 15.7562C9.48177 16.0813 6.51706 16.0813 3.57934 15.7562C1.85492 15.563 0.462732 14.208 0.260747 12.4771C-0.0869155 9.50246 -0.0869155 6.49754 0.260747 3.52289C0.462732 1.79197 1.85586 0.436068 3.57934 0.243849ZM12.2628 1.6478C9.42922 1.33425 6.56961 1.33425 3.73602 1.6478C3.21147 1.7059 2.72185 1.93884 2.34627 2.309C1.97069 2.67916 1.73108 3.16491 1.66615 3.68778C1.33045 6.55314 1.33045 9.4478 1.66615 12.3132C1.73127 12.8359 1.97097 13.3214 2.34653 13.6914C2.7221 14.0613 3.21161 14.2941 3.73602 14.3522C6.54588 14.665 9.45295 14.665 12.2628 14.3522C12.7871 14.2939 13.2763 14.0611 13.6517 13.6911C14.0271 13.3211 14.2667 12.8357 14.3317 12.3132C14.6674 9.4478 14.6674 6.55314 14.3317 3.68778C14.2665 3.16539 14.0268 2.68018 13.6515 2.31042C13.2761 1.94066 12.7869 1.7079 12.2628 1.64969",
    fill: "url(#paint1_linear_2078_5169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2078_5169",
    x1: 7.99929,
    y1: 3.29492,
    x2: 7.99929,
    y2: 12.7043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13487"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2078_5169",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#843F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13487"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3263e1fccb50a9c6150b479a7efc064e.svg";
export { ForwardRef as ReactComponent };